import React from 'react'

import { useRecoilValue } from 'recoil'

import classnames from 'classnames'

import ErrorFeedback from 'Components/ErrorFeedback'
import { pageState } from '../../recoil/state/page'

const InlineMessageBox = () => {
  const { inlineMessage, inlineMessageSeverity } = useRecoilValue(pageState)

  return (
    <ErrorFeedback
      error={inlineMessage}
      severity={inlineMessageSeverity}
      data-mu-test={classnames(
        'message-box',
        `message-box__${inlineMessageSeverity}`
      )}
    />
  )
}

export default InlineMessageBox
